class jfRetryMessages {
    constructor($scope, $timeout, XRayUtils, JFrogTableViewOptions, JFrogModal, $state, XrayMaintenanceDao) {
        this.TemplateGenerator = JFrogTableViewOptions.cellTemplateGenerators;
        this.retryTableViewOptions = new JFrogTableViewOptions($scope);
        this.$timeout = $timeout;
        this.MaintenanceDao = XrayMaintenanceDao;
        this.$state = $state;
        this.xrayUtils = XRayUtils;
        this.$scope = $scope;
    }

    $onInit() {
        this.createGrid();
        this.getRetryQueue();
    }

    createGrid() {
        this.retryTableViewOptions.setId('retry-table')
            .setObjectName('Queue/Queues')
            .setColumns(this.getColumns())
            .setRowsPerPage(10)
            .setActions(this.getActions())
            .setBatchActions(this.getBatchActions())
        this.retryTableViewOptions.newEntityCustomText = 'New Rule';
        this.retryTableViewOptions.on('row.clicked', (data) => {
        });


    }

    getBatchActions() {
        return [
            {
                icon: 'refresh',
                name: 'Retry Selected',
                callback: () => {
                    let selected = this.retryTableViewOptions.getSelectedRows();
                    console.log("Selected rows are", selected);
                    this.retryQueue(selected, false);
                },

            }
        ]
    };

    normalizeQueueName(queue) {
        return _.startCase(queue).replace('Retry', '')
    }

    getRetryQueue() {
        this.MaintenanceDao.getRetryQueues().$promise.then((response) => {
            this.retryTableViewOptions.setData(response);
            this.retryTableViewOptions.isRowSelectable = (row) => {
                console.log('row is', row);
                return row.entity.messages_count > 0
            };
            this.showGrid = true;

        })

    }

    retryQueue(row, single = true) {

        let payload = {};
        if (single) {
            payload.queues = [row.queue_name]
        } else {
            payload.queues = _.map(row, 'queue_name')
        }

        this.MaintenanceDao.retryMessages(payload).$promise.then((response) => {
            this.getRetryQueue();

        });
    }

    getColumns() {

        let cols = [
            {
                "header": "Queue",
                "field": "queue_name",
                'cellTemplate': `<div class="{{row.entity.priority}}">{{grid.appScope.jfRetryMessages.normalizeQueueName(row.entity.queue_name)}}</div>`,
                "width": "50%",

            },
            {
                "header": "Messages Count",
                "field": "messages_count",
                "width": "50%",
                'sortable': false
            }]
        return cols;
    }

    getActions() {
        return [
            {
                icon: 'icon icon-replace',
                tooltip: 'Retry',
                callback: (row) => this.retryQueue(row),
                visibleWhen: (row) => row.messages_count > 0
            },

        ];
    }
}

export function jfRetryMessages() {

    return {
        restrict: 'E',
        scope: {
            $dismiss: '&',
            $close: '&',
            policyRules: '=',
            policyType: '='
        },
        controller: jfRetryMessages,
        controllerAs: 'jfRetryMessages',
        template: require('./jf_retry_messages.html'),
        bindToController: true
    };
}




// WEBPACK FOOTER //
// ./modules/xray/directives/jf_retry_messages/jf_retry_messages.js